import { type MouseEventData } from '../external-types';
import { fabric } from 'fabric';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';

// Brush for panning
class PanBrush extends fabric.BaseBrush {
  // If a user activates panning while already holding the
  // mouse down, onMouseMove cannot execute successfully.
  // A mouse down event is required to begin
  _hasReceivedMouseDown = false;
  private readonly canvas: Canvas;
  previousX: number | null;
  previousY: number | null;

  constructor({ canvas }: { canvas: Canvas }) {
    super();
    this.canvas = canvas;
    this.previousX = null;
    this.previousY = null;
    this._hasReceivedMouseDown = false;
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    this.previousX = eventData.e.clientX;
    this.previousY = eventData.e.clientY;

    // Disable right click events when panning with left click
    if (eventData.e?.buttons === 1) {
      this.canvas.fireRightClick = false;
    }

    this.canvas.setDrawingCursor('grabbing');
    this._hasReceivedMouseDown = true;
    this.canvas.controller.actionSetPanning();
  }

  onMouseMove(pointer: IPoint, eventData: MouseEventData) {
    if (
      !this._hasReceivedMouseDown ||
      !this.previousX ||
      !this.previousY ||
      !this.canvas.controller.allowPanAndZoom()
    ) {
      return;
    }

    const { clientX, clientY } = eventData.e;
    this.canvas.relativePan(
      new fabric.Point(clientX - this.previousX, clientY - this.previousY)
    );
    this.previousX = clientX;
    this.previousY = clientY;
    this.canvas.temporaryHideObjectToolbar();
  }

  onMouseUp() {
    this.canvas.fireRightClick = true;
    this.canvas.setDrawingCursor('grab');

    if (this._hasReceivedMouseDown) {
      this.canvas.controller.actionClearPanning();
    }
    this._hasReceivedMouseDown = false;
  }

  _render() {}
}

export default PanBrush;
